(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["equ-home-quotes"] && !Shopify.designMode) return;
  try {
    
function equHomeInitQuotes(root){var sections=Array.from(root.querySelectorAll('[data-equ-quotes]'));if(root.matches&&root.matches('[data-equ-quotes]'))sections.unshift(root);sections.forEach(function(section){if(section.dataset.equQuotesReady)return;section.dataset.equQuotesReady='true';var track=section.querySelector('[data-equ-quotes-track]');var slides=Array.from(section.querySelectorAll('[data-equ-quote-slide]'));var dots=Array.from(section.querySelectorAll('[data-equ-quotes-index]'));if(!track||!slides.length)return;function update(index){dots.forEach(function(dot,i){if(i===index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')})}function go(index){var target=(index+slides.length)%slides.length;track.scrollTo({left:slides[target].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});update(target)}section.addEventListener('click',function(event){var direction=event.target.closest('[data-equ-quotes-direction]');var dot=event.target.closest('[data-equ-quotes-index]');if(!direction&&!dot)return;var active=dots.findIndex(function(item){return item.getAttribute('aria-current')==='true'});if(direction)go(active+Number(direction.dataset.equQuotesDirection));if(dot)go(Number(dot.dataset.equQuotesIndex))});var tick=0;track.addEventListener('scroll',function(){cancelAnimationFrame(tick);tick=requestAnimationFrame(function(){var index=slides.reduce(function(best,slide,i){return Math.abs(slide.offsetLeft-track.scrollLeft)<Math.abs(slides[best].offsetLeft-track.scrollLeft)?i:best},0);update(index)})},{passive:true})})}equHomeInitQuotes(document);document.addEventListener('shopify:section:load',function(event){equHomeInitQuotes(event.target)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equelle-faq-directory"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    if (!event.target.matches('.equelle-faq-directory__search')) return;
    const section = event.target.closest('.equelle-faq-directory');
    if (!section) return;
    const query = event.target.value.trim().toLocaleLowerCase();
    let total = 0;
    section.querySelectorAll('.equelle-faq-directory__item').forEach((item) => {
      const matches = item.textContent.toLocaleLowerCase().includes(query);
      item.hidden = !matches;
      if (matches) total += 1;
    });
    section.querySelectorAll('.equelle-faq-directory__category').forEach((heading) => {
      const id = heading.dataset.categoryId;
      const hasMatch = [...section.querySelectorAll('.equelle-faq-directory__item')].some((item) => item.dataset.categoryId === id && !item.hidden);
      heading.hidden = !hasMatch;
      const link = [...section.querySelectorAll('.equelle-faq-directory__nav a')].find((item) => item.dataset.categoryId === id);
      if (link) link.hidden = !hasMatch;
    });
    const empty = section.querySelector('.equelle-faq-directory__empty');
    if (empty) empty.hidden = total !== 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equelle-faq-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    if (!event.target.matches('.equelle-faq__search')) return;
    const section = event.target.closest('.equelle-faq');
    if (!section) return;
    const query = event.target.value.trim().toLocaleLowerCase();
    let visible = 0;
    section.querySelectorAll('.equelle-faq__item').forEach((item) => {
      const matches = item.textContent.toLocaleLowerCase().includes(query);
      item.hidden = !matches;
      if (matches) visible += 1;
    });
    const empty = section.querySelector('.equelle-faq__empty');
    if (empty) empty.hidden = visible !== 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equelle-page-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('.equelle-page-hero__video-open') : null;
    if (!button) return;
    const shell = button.closest('.equelle-page-hero__video-shell');
    const video = shell?.querySelector('video');
    const cover = shell?.querySelector('.equelle-page-hero__video-cover');
    if (!video || !cover) return;
    cover.hidden = true;
    const started = video.play();
    if (started?.catch) started.catch(() => { cover.hidden = false; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["equelle-product-main-shopfinity"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('equelle-product-gallery')) {
    customElements.define('equelle-product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-equ-gallery-track]');
        this.thumbs = [...this.querySelectorAll('[data-equ-gallery-index]')];
        this.onClick = (event) => {
          const button = event.target.closest('[data-equ-gallery-index]');
          if (!button || !this.contains(button) || !this.track) return;
          const index = Number(button.dataset.equGalleryIndex);
          const slide = this.track.children[index];
          if (!slide) return;
          this.track.querySelectorAll('video').forEach((video) => { if (!slide.contains(video)) video.pause(); });
          this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
          this.thumbs.forEach((thumb) => thumb.setAttribute('aria-current', String(thumb === button)));
        };
        this.addEventListener('click', this.onClick);
      }
      disconnectedCallback() { this.removeEventListener('click', this.onClick); }
    });
  }

  if (!window.equelleBundlePickerBound) {
    window.equelleBundlePickerBound = true;
    document.addEventListener('click', (event) => {
      const option = event.target.closest('[data-equ-bundle]');
      const picker = option && option.closest('[data-equ-bundle-picker]');
      if (!picker) return;
      const form = picker.closest('form');
      const quantity = form && form.querySelector('[name="quantity"]');
      const label = form && form.querySelector('.main-atc__label__text');
      if (!quantity) return;
      quantity.value = option.dataset.equBundle;
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
      picker.querySelectorAll('[data-equ-bundle]').forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
      if (label && !form.querySelector('[data-unavailable="true"]')) label.textContent = picker.dataset.equBuyPrefix + ' ' + option.dataset.equPrice;
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
